import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthenticationService } from 'src/app/services/auth/authentication.service';
import { SharedService } from 'src/app/services/shared/shared.service';
const misc: any = {
    sidebar_mini_active: true
};

export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icontype: string;
    iconPath: string;
    iconPathActive: string;
    collapse?: string;
    isCollapsed?: boolean;
    isCollapsing?: any;
    children?: ChildrenItems[];
    gardName?: string;
}

export interface ChildrenItems {
    path: string;
    title: string;
    type?: string;
    collapse?: string;
    children?: ChildrenItems2[];
    isCollapsed?: boolean;
    gardName?: string;
}

export interface ChildrenItems2 {
    path?: string;
    title?: string;
    type?: string;
}
// Menu Items
export const ROUTES: RouteInfo[] = [
    {
        path: '/dashboard',
        title: 'Dashboard',
        type: 'link',
        icontype: 'ni ni-dashboard',
        iconPath: 'assets/img/icons/sidebar/dashboard.svg',
        iconPathActive: 'assets/img/icons/sidebar/dashboard_active.svg',
        gardName: 'dashboard-view'
    },
    {
        path: '/orders',
        title: 'Orders',
        type: 'link',
        icontype: 'ni-basket',
        iconPath: 'assets/img/icons/sidebar/order.svg',
        iconPathActive: 'assets/img/icons/sidebar/order_active.svg',
        gardName: 'orders-view'
    },
    {
        path: '/calendar-view',
        title: 'Order Schedule',
        type: 'link',
        icontype: 'ni-calendar-grid-58',  // Example icon for calendar
        iconPath: 'assets/img/icons/sidebar/Order_Schedule.svg',
        iconPathActive: 'assets/img/icons/sidebar/Order_Schedule_active.svg',
        gardName: 'dispatch-view'          // Adjust if you need a specific guard
    },
    // {
    //     path: "/plans",
    //     title: "Plans",
    //     type: "link",
    //     icontype: "ni-single-copy-04",
    //     gardName: "customers-view"
    // },
    {
        path: '/phlebos',
        title: 'Phlebos',
        type: 'sub',
        icontype: 'ni-satisfied',
        iconPath: 'assets/img/icons/sidebar/phlebo.svg',
        iconPathActive: 'assets/img/icons/sidebar/phlebo_active.svg',
        collapse: 'setting',
        isCollapsed: true,
        gardName: 'phlebos-view',
        children: [
            { path: 'list', title: 'List of Phlebos', type: 'link' },
            { path: 'distance-reports', title: 'Distance Report', type: 'link' },
            { path: 'rosters', title: 'Rosters', type: 'link' },
              { path: 'live-view', title: 'Live Location', type: 'link', gardName: 'phlebos-tracking' },
            { path: 'leaves', title: 'Leaves', type: 'link' },
        ]
    },
    {
        path: '/reviews',
        title: 'Reviews',
        type: 'sub',
        icontype: 'ni-satisfied',
        iconPath: 'assets/img/icons/sidebar/phlebo.svg',
        iconPathActive: 'assets/img/icons/sidebar/phlebo_active.svg',
        collapse: 'setting',
        isCollapsed: true,
        gardName: 'reviews-view',
        children: [
            // { path: "app", title: "App review", type: "link" },
            { path: 'phlebos', title: 'Phlebo\'s review', type: 'link' },
        ]
    },
    {
        path: '/runner',
        title: 'Runners',
        type: 'sub',
        icontype: 'ni-user-run',
        iconPath: 'assets/img/icons/sidebar/runner.svg',
        iconPathActive: 'assets/img/icons/sidebar/runner_active.svg',
        collapse: 'runner',
        isCollapsed: true,
        gardName: 'runner-view',
        children: [
            { path: 'list', title: 'List of Runner', type: 'link' },
            { path: 'task', title: 'Tasks', type: 'link' },
            { path: 'tour', title: 'Tour Template', type: 'link' },
            { path: 'live-view', title: 'Live View', type: 'link' },
            { path: 'leaves', title: 'Leaves', type: 'link' },
            // { path: "distance-reports", title: "Distance Report", type: "link" },
            { path: 'item-reports', title: 'Item Report', type: 'link' },
            { path: 'location-reports', title: 'Location Report', type: 'link' },
        ]
    },
    {
        path: '/sales',
        title: 'Sales',
        type: 'sub',
        icontype: 'ni-cart',
        iconPath: 'assets/img/icons/sidebar/dashboard.svg',
        iconPathActive: 'assets/img/icons/sidebar/dashboard_active.svg',
        collapse: 'runner',
        isCollapsed: true,
        gardName: 'runner-view',
        children: [
            { path: 'prospect', title: 'Prospect', type: 'link' },
            { path: 'appointment', title: 'Appointment', type: 'link' },
            { path: 'complain', title: 'Complain', type: 'link' },
            //   { path: "client", title: "Clients", type: "link" },
            { path: 'team', title: 'Team', type: 'link' },
            { path: 'sales-report', title: 'Sales Reports', type: 'link' },
            { path: 'sales-reps', title: 'Sales Representative', type: 'link' },
            { path: 'sales-target', title: 'Sales Target Master', type: 'link' },
        ]
    },
    {
        path: '/users',
        title: 'Users',
        type: 'link',
        icontype: 'ni-circle-08',
        iconPath: 'assets/img/icons/sidebar/user.svg',
        iconPathActive: 'assets/img/icons/sidebar/user_active.svg',
        gardName: 'users-view'
    },

    // {
    //     path: "/support",
    //     title: "Support",
    //     type: "sub",
    //     icontype: "ni-support-16",
    //     collapse: "setting",
    //     isCollapsed: true,
    //     gardName: "setting-cart",
    //     children: [
    //         { path: "ticket", title: "Tickets", type: "link" },
    //     ]
    // },
    {
        path: "/customers",
        title: "Patients",
        type: "link",
        icontype: "ni-single-02",
        iconPath: "assets/img/icons/sidebar/customer.svg",
        iconPathActive: "assets/img/icons/sidebar/customer_active.svg", 
        gardName: "customers-view"
    },


    // {
    //     path: "/avslots",
    //     title: "Available Slots",
    //     type: "link",
    //     icontype: "ni-single-02",
    //     iconPath: "assets/img/icons/sidebar/customer.svg",
    //     iconPathActive: "assets/img/icons/sidebar/customer_active.svg",
    //     gardName: "slots-view"
    // },




    // {
    //     path: "/patients",
    //     title: "Patients",
    //     type: "link",
    //     icontype: "ni-archive-2 ",
    //     gardName: "patients-view"
    // },


    // {
    //     path: "/myaccount/viewprofile",
    //     title: "My Account",
    //     type: "link",
    //     icontype: "ni-satisfied",
    //     gardName: "my-account-view"

    // },
    // {
    //     path: "/invoice-payment",
    //     title: "Invoice and Payment",
    //     type: "link",
    //     icontype: "ni-money-coins",
    //     gardName: "invoice-and-payment-view"
    // },
    //  {
    //      path: "payment/phleboview",
    //      title: "Payment Reconciliation",
    //      type: "link",
    //      icontype: "ni-money-coins",
    //     gardName: "reconcile-view"
    //  },
    // {
    //     path: "bankdeposit",
    //     title: "Bank Deposit",
    //     type: "link",
    //     icontype: "ni-money-coins",
    //     gardName: "reconcile-view"
    //  //  gardName: "setting-view"
    // },
       /* {
        path: "/reports",
        title: "Report",
        type: "sub",
        icontype: "ni-settings",
        collapse: "report",
        isCollapsed: true,
        gardName: "report-view",
        children: [
        { path: "payment/phleboview", title: "Payment Reconciliation", type: "link" },
        ]
        },*/

        {
            path: '/finance-report',
            title: 'Finance Report',
            type: 'link',
            icontype: 'ni-basket',
            iconPath: 'assets/img/icons/sidebar/finance.svg',
            iconPathActive: 'assets/img/icons/sidebar/finance_active.svg',
            gardName: 'finance-report'
        },
        {
            path: '/payable-report',
            title: 'Account Payable',
            type: 'link',
            icontype: 'ni-basket',
            iconPath: 'assets/img/icons/sidebar/finance.svg',
            iconPathActive: 'assets/img/icons/sidebar/finance_active.svg',
            gardName: 'account-payable'
        },
        {
            path: '/receivable-report',
            title: 'Account Receivable',
            type: 'link',
            icontype: 'ni-basket',
            iconPath: 'assets/img/icons/sidebar/finance.svg',
            iconPathActive: 'assets/img/icons/sidebar/finance_active.svg',
            gardName: 'account-receivable'
        },

        {
            path: '/settings',
            title: 'Setting',
            type: 'sub',
            icontype: 'ni-settings',
            iconPath: 'assets/img/icons/sidebar/setting.svg',
            iconPathActive: 'assets/img/icons/sidebar/Active_Setting.svg',
            collapse: 'setting',
            isCollapsed: true,
            gardName: 'setting-view',
            children: [
                // { path: "customerdos", title: "Customer Dos", type: "link" },
                // { path: "masterdos", title: "Master Dos", type: "link" },
                { path: 'cities', title: 'Cities', type: 'link', gardName: 'setting-city' },
                { path: 'areacode', title: 'Areacodes', type: 'link', gardName: 'setting-areacode' },
                { path: 'pincode', title: 'Zip Codes', type: 'link', gardName: 'setting-zipcode' },
                { path: 'lab', title: 'Labs', type: 'link', gardName: 'setting-lab' },
                { path: 'location', title: 'Lab Locations', type: 'link', gardName: 'setting-location' },
                { path: 'device', title: 'Devices', type: 'link', gardName: 'setting-device' },
                { path: 'device-inventory', title: 'Device Inventory', type: 'link', gardName: 'setting-device' },
                
                { path: 'facility', title: 'Facilities', type: 'link', gardName: 'setting-facility' },
                { path: 'order-provider', title: 'Order Providers', type: 'link', gardName: 'setting-provider' },
                // { path: "customerblock", title: "Block Order", type: "link" },
                // { path: "masterdos", title: "Master DoS", type: "link" },
                { path: 'customerdos', title: 'DOS', type: 'link', gardName: 'setting-dos' },
                // { path: "coupon", title: "Coupon", type: "link" },
                // { path: "banner", title: "Banner", type: "link" },
                { path: 'role', title: 'Roles', type: 'link', gardName: 'setting-role' },
                // { path: "system-setting", title: "System Setting", type: "link" },
                // { path: "lablocation", title: "Lab Location", type: "link" },
                { path: 'email-notification', title: 'Notifications', type: 'link', gardName: 'setting-email' },
                { path: 'app-setting', title: 'App Settings', type: 'link', gardName: 'setting-app' },
                { path: 'order-setting', title: 'Order Settings', type: 'link', gardName: 'setting-order' },
                { path: 'slot-setting', title: 'Slot Settings', type: 'link', gardName: 'setting-slot' },
                { path: 'cancel-reason', title: 'Cancellation Reasons', type: 'link', gardName: 'setting-role' },
                { path: 'reschedule-reason', title: 'Reschedule Reasons', type: 'link', gardName: 'setting-role' },

            ]
        },
    // {
    //     path: "/prescription-uploads",
    //     title: "Prescription uploads",
    //     type: "link",
    //     icontype: "ni-album-2",
    //     gardName: "prescription-view"
    // },
    //     {
    //       path: "/report",
    //       title: "Repor",
    //       type: "link",
    //       icontype: "ni-album-2",
    //       gardName: "users-report"
    //   },
];

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
    public menuItems: any[];
    public isCollapsed = true;
    public logoPath = '';
    constructor(public authService: AuthenticationService, private sharedService: SharedService, private router: Router) { }
    isActive(menuitem: any): boolean {
        return this.router.url.startsWith(menuitem.path);

    }

    ngOnInit() {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const customerId = user.customer_id;

        // if (customerId === 55) {
        //     this.logoPath = 'assets/img/brand/ICTLOGO1.png';
        // } else {
            this.logoPath = 'assets/img/brand/icon_logo.svg';
        // }

        const Filteritem = [];
        const showRunner = localStorage.getItem('show_runner') == 'true' || localStorage.getItem('show_runner') == '1';
        const showSales = localStorage.getItem('show_sales') == 'true' || localStorage.getItem('show_sales') == '1';
        const showFinanceReport = localStorage.getItem('show_finance_report') == 'true' || localStorage.getItem('show_finance_report') == '1';
        const isDeviceService = localStorage.getItem('is_device_service') == 'true' || localStorage.getItem('is_device_service') == '1';
        const showDistanceReport = localStorage.getItem('show_distance_report') == 'true' || localStorage.getItem('show_distance_report') == '1';
        ROUTES.forEach(item => {
            if (item.path === '/phlebos') {
            item.title = isDeviceService ? 'Field Officer' : 'Phlebos';

            // update children as well
            item.children?.forEach(child => {
                if (child.title.includes('Phlebo')) {
                child.title = isDeviceService
                    ? child.title.replace('Phlebo', 'Field Officer')
                    : child.title.replace('Field Officer', 'Phlebo');
                }
            });
            }

            if (item.path === '/reviews') {
            item.children?.forEach(child => {
                if (child.title.includes('Phlebo')) {
                child.title = isDeviceService
                    ? child.title.replace('Phlebo', 'Field Officer')
                    : child.title.replace('Field Officer', 'Phlebo');
                }
            });
            }
        });
        ROUTES.filter(item => {


            this.authService.permissions.map(per => {
                if (per == item.gardName) {
                    if (item.path === '/runner' && !showRunner) {
                        return;
                    }
                    if (item.path === '/sales' && !showSales) {
                        return;
                    }
                    if (item.path === '/finance-report' && !showFinanceReport) {
                        return;
                    }
                    // if (item.path === "/phlebos/distance-reports" && !showDistanceReport) {
                    //     return;
                    // }
                    if (item.children && item.children.length > 0) {
                        item.children = item.children.filter(child =>
                            !child.gardName || this.authService.permissions.includes(child.gardName)
                        );

                        if (item.children.length === 0) return;
                    }
                    Filteritem.push(item);
                }
            });
            // Filteritem.push(item);
        });
        this.menuItems = Filteritem;

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
              const currentRoute = this.router.url.split('?')[0];

              const activeRoute = this.menuItems.find((item) =>
                currentRoute.startsWith(item.path)
              );
              const activeTabName = activeRoute ? activeRoute.title : '';
              this.sharedService.setActiveTab(activeTabName); // Update the active tab in the shared service
            }
          });
        this.router.events.subscribe(event => {
            this.isCollapsed = true;
        });
    }
    // New ngoninit  24042025
    // ngOnInit() {
    //     const user = JSON.parse(localStorage.getItem('user') || '{}');
    //     const customerId = user.customer_id;

    //     this.logoPath = 'assets/img/brand/icon_logo.svg';

    //     const showRunner = localStorage.getItem('show_runner') == 'true' || localStorage.getItem('show_runner') == '1';
    //     const showSales = localStorage.getItem('show_sales') == 'true' || localStorage.getItem('show_sales') == '1';
    //     const showFinanceReport = localStorage.getItem('show_finance_report') == 'true' || localStorage.getItem('show_finance_report') == '1';
    //     const showDistanceReport = localStorage.getItem('show_distance_report') == 'true' || localStorage.getItem('show_distance_report') == '1';

    //     const permissions = this.authService.permissions;

    //     // Recursive filter function
    //     const filterMenu = (menu: RouteInfo[]): RouteInfo[] => {
    //         return menu
    //             .filter(item => {
    //                 // Check for permission at top level
    //                 const hasPermission = !item.gardName || permissions.includes(item.gardName);

    //                 // Custom visibility checks
    //                 if (item.path === "/runner" && !showRunner) return false;
    //                 if (item.path === "/sales" && !showSales) return false;
    //                 if (item.path === "/finance-report" && !showFinanceReport) return false;

    //                 // Handle children
    //                 if (item.children && item.children.length > 0) {
    //                     const filteredChildren = item.children.filter(child => {
    //                         return !child.gardName || permissions.includes(child.gardName);
    //                     });

    //                     // Only keep parent if at least one child is visible
    //                     if (filteredChildren.length > 0) {
    //                         item.children = filteredChildren;
    //                         return true;
    //                     } else {
    //                         return false;
    //                     }
    //                 }

    //                 return hasPermission;
    //             });
    //     };

    //     this.menuItems = filterMenu(ROUTES);

    //     // Handle active route name for tab highlighting
    //     this.router.events.subscribe((event) => {
    //         if (event instanceof NavigationEnd) {
    //             const currentRoute = this.router.url.split('?')[0];
    //             const activeRoute = this.menuItems.find(item => currentRoute.startsWith(item.path));
    //             const activeTabName = activeRoute ? activeRoute.title : '';
    //             this.sharedService.setActiveTab(activeTabName);
    //         }
    //     });

    //     this.router.events.subscribe(() => {
    //         this.isCollapsed = true;
    //     });
    // }
    onMouseEnterSidenav() {
        if (!document.body.classList.contains('g-sidenav-pinned')) {
            document.body.classList.add('g-sidenav-show');
        }
    }
    onMouseLeaveSidenav() {
        if (!document.body.classList.contains('g-sidenav-pinned')) {
            document.body.classList.remove('g-sidenav-show');
        }
    }
    minimizeSidebar() {
        const sidenavToggler = document.getElementsByClassName(
            'sidenav-toggler'
        )[0];
        const body = document.getElementsByTagName('body')[0];
        if (body.classList.contains('g-sidenav-pinned')) {
            misc.sidebar_mini_active = true;
        } else {
            misc.sidebar_mini_active = false;
        }
        if (misc.sidebar_mini_active === true) {
            body.classList.remove('g-sidenav-pinned');
            body.classList.add('g-sidenav-hidden');
            sidenavToggler.classList.remove('active');
            misc.sidebar_mini_active = false;
        } else {
            body.classList.add('g-sidenav-pinned');
            body.classList.remove('g-sidenav-hidden');
            sidenavToggler.classList.add('active');
            misc.sidebar_mini_active = true;
        }
    }
}
